







































































/* General */
import Vue from 'vue'
import MailboxSettingsLayout from '@/layouts/mailbox-settings-layout.vue'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { IMailboxesOutputTicketPortal } from '@/api/types/response.types'

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'

export default Vue.extend({
  name: 'MailboxSettingsTicketPortal',

  metaInfo(): any {
    return {
      title: `Ticket Portal - ${this.name}`,
    }
  },

  components: {
    MailboxSettingsLayout,
    EntitySettingsLoading,
  },

  data() {
    return {
      RouteAssistant,
      ColorAssistant,
      isLoading: true,
      isSubmitting: false,
      clipboard: null,
      name: '',
      ticketPortalSettings: {} as IMailboxesOutputTicketPortal,
    }
  },
  computed: {
    id(): number {
      return parseInt(this.$route.params.id, 10)
    },
    enabledText(): string {
      return this.ticketPortalSettings.enabled ? 'enabled' : 'disabled'
    },
  },
  watch: {
    'ticketPortalSettings.enabled': {
      immediate: false,
      async handler(val: boolean) {
        if (!this.isLoading) {
          await this.save()
        }
      },
    },
  },

  async created() {
    this.isLoading = true
    if (this.$permissions.ticketPortalFeatureEnabled) {
      await this.getTicketPortalSettings()
    } else {
      await this.getTitle()
    }
    this.isLoading = false
  },

  methods: {
    async getTicketPortalSettings() {
      try {
        const response = await MailboxesAPI.get_TicketPortal(this.id)
        this.name = response.name
        this.ticketPortalSettings = response
      } catch (error) {
        this.$error.emit(error)
      }
    },
    async getTitle() {
      try {
        const response = await MailboxesAPI.get_Title(this.id)
        this.name = response.name
      } catch (error) {
        this.$error.emit(error)
      }
    },
    async save() {
      try {
        this.isSubmitting = true
        const response = await MailboxesAPI.put_TicketPortal(this.id, {
          enabled: this.ticketPortalSettings.enabled,
          ticketPortalName: this.ticketPortalSettings.ticketPortalName,
          showRefNumber: this.ticketPortalSettings.showRefNumber,
          showStatuses: this.ticketPortalSettings.showStatuses,
          showAccountLogo: this.ticketPortalSettings.showAccountLogo,
        })
        await this.getTicketPortalSettings()
        this.isSubmitting = false
        this.$messaging.showSuccess(response.message)
      } catch (error) {
        this.$error.emit(error)
      }
    },
  },
})
